<template>
  <div :class="['content', programStyle]">
    <div class="title-container">
      <div class="title">{{ $t('dealer-rental-agency-form') }}</div>
    </div>
    <div v-if="mostRecentStatus && mostRecentStatus.result && mostRecentStatus.reason" class="review-container">
      <div :class="['result-container', mostRecentStatus.result === 'Declined' ? 'red' : 'green']">
        {{ mostRecentStatus.result }}
      </div>
      <div class="reason">{{ $t('reason', [mostRecentStatus.reason]) }}</div>
    </div>
    <form class="form-container" @submit.prevent="save">
      <div class="item-container" v-for="(appeal, index) in appeals" :key="appeal.dialId">
        <div class="left-container flex-column">
          <div v-if="index === 0" :class="['circle', appeal.dialColor]">
            <div class="inner" v-if="appeal.dialResultText">
              {{ appeal.dialResultText }}
            </div>
          </div>
        </div>
        <div class="right-container flex-column">
          <div v-if="index === 0" class="title-small">{{ $t('proof-of-state-license') }}</div>
          <div class="subtitle">{{ appeal.dialTitle }}</div>
          <Upload v-if="!appeal.uploads" :appeal="appeal" v-on:sendurl="getUrl" />
          <div v-if="appeal.uploads">
            <div class="support-docs" v-for="upload in appeal.uploads" :key="upload.key">
              <span v-if="upload.label === appeal.dialTitle">{{ upload.originalFilename }}</span>
              <a v-if="upload.label === appeal.dialTitle" class="relative" target="_blank" :href="upload.url">
                <img class="download-icon" src="@/assets/img/download-arrow.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-container flex-column">
        <div class="bottom-info">
          <div class="flex-column">
            <span>Date:</span>
            <div v-if="!otherAppealInfo" class="date">{{ date | date }}</div>
            <div v-if="otherAppealInfo" class="date">{{ otherAppealInfo.formCreatedAt | date }}</div>
          </div>
          <div class="flex-column">
            <span>Signature:</span>
            <input readonly v-if="!otherAppealInfo" v-model="signature" />
            <input readonly v-if="otherAppealInfo" v-model="otherAppealInfo.dealerSignature" />
          </div>
        </div>
        <div class="button-container">
          <button class="small-btn" @click="exit">{{ $t('exit') }}</button>
          <button
            v-if="appealType !== 'view'"
            value="save"
            :class="[uploadValidationCheck ? '' : 'disabled', 'small-btn']"
            :disabled="!uploadValidationCheck && !loader"
          >
            {{ $t('submit') }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Upload from '@/components/Upload.vue';
import { mapState } from 'vuex';

export default {
  name: 'Rental',
  components: { Upload },
  props: {
    appealType: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      appeals: [],
      uploads: [],
      date: new Date(),
      loader: null,
    };
  },
  methods: {
    save() {
      this.loader = this.$loading.show();

      const { entity, domain, signature } = this;
      const items = [];

      this.appeals.forEach((appeal) => {
        items.push(appeal);
      });

      const params = {
        domain,
        entity,
        items,
        uploads: this.uploads,
        status: 'submit',
        dealerSignature: signature,
        type: 'Dealer Loaner',
        layout: 'Rental',
        result: 'Submitted',
        configId: this.config.id,
      };
      this.submitForm(params);
    },
    submitForm(params) {
      this.$store
        .dispatch('submitForm', params)
        .then(() => {
          this.exit();
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          this.loader.hide();
        });
    },
    exit() {
      this.$router.push({
        name: 'Dealer-Forms',
      });
    },
    getUrl(res) {
      const upload = {
        originalFilename: res.res.data.fileInfo.originalFilename,
        adjustedFilename: res.res.data.fileInfo.adjustedFilename,
        label: res.appeal.dialTitle,
        dialId: res.appeal.dialId,
      };
      this.uploads.push(upload);
    },
    getAppeals() {
      if (this.appealType === 'view') {
        this.appeals = JSON.parse(JSON.stringify(this.selectedForm));
      } else {
        this.appeals = [
          {
            dialColor: 'N',
            dialId: '0',
            dialResultText: '',
            dialTitle: '',
          },
        ];
      }
    },
  },
  computed: {
    ...mapState('global', ['programStyle', 'programName']),
    ...mapState(['selectedForm', 'otherAppealInfo']),
    entity() {
      return this.$route.params.entity;
    },
    domain() {
      return this.$route.params.domain;
    },
    rows() {
      if (this.archiveResults && this.value) {
        return this.archiveResults[this.value.value];
      }
      return null;
    },
    mostRecentStatus() {
      if (this.otherAppealInfo) {
        return this.otherAppealInfo.statuses[0];
      }
      return null;
    },
    signature() {
      const user = JSON.parse(localStorage.getItem('stellantis-user'));
      const fullName = `${user.firstName} ${user.lastName}`;

      return fullName;
    },
    uploadValidationCheck() {
      let valid = true;

      this.appeals.forEach((appeal) => {
        if (valid) {
          if (appeal.dialId !== '1') {
            valid = this.uploads.some((upload) => upload.dialId === appeal.dialId);
          }
        }
      });
      return valid;
    },
  },
  watch: {},
  created() {
    this.getAppeals();
  },
  beforeDestroy() {
    this.$emit('exit');
  },
};
</script>

<style lang="scss" scoped>
.content {
  color: #000000;
  text-align: left;
  .link {
    color: #243882;
  }
}
.title-container {
  margin-left: 30px;
  margin-top: 30px;
}
.title {
  margin-bottom: 24px;
  color: #243882;
  font-size: 21px;
}
.title-small {
  font-size: 16px;
  margin-bottom: 20px;
}
.item-container {
  display: flex;
  margin: 0 30px 30px 30px;
}
.right-container {
  width: 100%;
  margin-left: 10px;
  font-size: 14px;
  input {
    height: 100px;
    width: initial;
    background: $input-background;
    border: none;
    margin-bottom: 20px;
  }
  .support-docs {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
  .item {
    display: flex;
    flex-direction: column;
  }
}
.left-container {
  min-width: 80px;
}
.subtitle {
  font-size: 14px;
  margin-bottom: 10px;
}
.description {
  margin: 10px 0;
}
.bottom-container {
  margin: 50px 0 20px 30px;
}
.bottom-info {
  display: flex;
  input {
    width: initial;
    background: $input-background;
    border: none;
    margin-bottom: 20px;
    margin-right: 30px;
    &:read-only {
      cursor: default;
    }
  }
}
.button-container {
  display: flex;
  margin-top: 40px;
  align-items: center;
  justify-content: center;
  button {
    margin-right: 30px;
  }
}
.date {
  width: 160px;
  background: $input-background;
  border: none;
  margin-bottom: 20px;
  margin-right: 20px;
  padding: 13px 0px 13px 20px;
}
</style>
